import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// Decorators
import connection from '@src/connection';

// Containers
import Templates from 'containers/Home/Templates';

// Constants
import * as ROUTES from 'constants/Routes';
import { SCREEN_TYPES } from 'constants/MogamboConstants';
import { getURLParams } from '@src/utils/fp';

import * as maps from './maps';
import styles from './Home.scss';

@connection(maps.listenToStores, maps.getStateFromStores)
export default class Home extends React.Component {
  componentDidMount() {
    maps.setCurrentScreen(SCREEN_TYPES.HOME);
  }

  getZohoRedirectionRoute() {
    const iva = JSON.parse(localStorage.getItem('ww_iva'));
    const domainId = iva?.domain_id || iva?.id || '';
    const businessId = iva?.business?.[0]?.id || '';
    const testConfigData = localStorage.getItem('testConfigData');
    let clientId = '';
    if (testConfigData) {
      clientId = JSON.parse(testConfigData).partner_client_id;
    }
    const queryParams = window.location.hash.startsWith('#/?')
      ? `/${window.location.hash.substring(3)}`
      : '/';

    const route = `${ROUTES.AGENT_ESCALATION_ROUTE(
      domainId,
      clientId,
      businessId
    )}/message_delivery_zoho${queryParams}`;
    return route;
  }

  render() {
    const params = getURLParams();
    const redirectRoute = this.getZohoRedirectionRoute();
    return (
      <div className={styles.home}>
        <div className={styles.card}>
          <Switch>
            {params?.zohoAuthorized !== 'true' ? (
              <Redirect exact from="/" to={`${ROUTES.BOTS}`} />
            ) : (
              <Redirect to={redirectRoute} />
            )}
            <Route
              exact
              path={`${ROUTES.ALL_SMART_SKILLS}`}
              component={Templates}
            />
          </Switch>
        </div>
      </div>
    );
  }
}
